/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { updatePageDetails, changePage } from '@insticator/insticator-ui';
import { updateStepDetails } from 'state/actions/embedsState/embedManagementState/embed_management_status';
import { invalidateSelectedContent } from 'state/actions/embedsState/embedManagementState/content_status';
import { sendMessage } from '@insticator/insticator-ui'; // iui-state
// component
import ArrowStep from 'material/embeds/steps/stepindicator/arrowstep/arrowstep';



/* ========== ~~~~~~~~~~ STEP INDICATOR : ARROW STEP : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }) => {
    const contentStatus = embedsState.embedManagementState.contentStatus;
    const currentStepIndex = embedsState.embedManagementState.embedManagementStatus.currentStepIndex;
    const stepQueue = embedsState.embedManagementState.embedManagementStatus.stepQueue;
    return {
        currentStepPage: embedsState.embedManagementState.embedManagementStatus.currentStepPage,
        currentStepIndex,
        currStepName: !currentStepIndex ? null : currentStepIndex >= 0 ? stepQueue[currentStepIndex]["name"] : null,
        selectedContent: !!contentStatus.contents ? contentStatus.contents[contentStatus.selectedContent] : null,
        isNewEmbedFlow: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.isNewEmbedFlow,
        isSavingData: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.isSavingData,
        changeDetected: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.embedChangeDetected ||
            embedsState.embedManagementState.contentStatus.contentChangeDetected
    }
};

// map actions
const mapDispatchToProps = dispatch => ({
	moveToPage: (location) => {
		dispatch(updatePageDetails(`dashboard/embeds/management/${location}`));
        dispatch(updateStepDetails(location));
    	dispatch(changePage(`dashboard/embeds/management/${location}`))
    },
    invalidateSelectedContent: () => dispatch(invalidateSelectedContent()),
    sendMessage: message => dispatch(sendMessage(message))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
	mapStateToProps,
    mapDispatchToProps
)(ArrowStep);
